/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';

import { AutomateFilter } from '../models';

@Component({
  selector: 'field-filter',
  templateUrl: './field-filter.component.html'
})
export class FieldFilterComponent implements OnInit {

  @Input()
  filter: AutomateFilter;

  @Output('onChange')
  onChange: EventEmitter<AutomateFilter> = new EventEmitter<AutomateFilter>();

  addingFilter: boolean = false;
  currentFilterType: string = 'include';
  currentFilterValue: string = '';

  constructor() { }

  ngOnInit() {
  }

  addFilter() {
    this.currentFilterValue = this.currentFilterValue.toLowerCase();
    if (this.currentFilterType == 'include') {
      if (this.filter.include.indexOf(this.currentFilterValue) < 0) {
        this.filter.include.push(this.currentFilterValue);
      }
    }
    else {
      if (this.filter.exclude.indexOf(this.currentFilterValue) < 0) {
        this.filter.exclude.push(this.currentFilterValue);
      }
    }
    this.cancelAddFilter();
    this.onChange.emit(this.filter);
  }

  removeFilter(type: string, value: string) {
    this.filter[type].splice(this.filter[type].indexOf(value), 1);
    this.onChange.emit(this.filter);
  }

  cancelAddFilter() {
    this.addingFilter = false;
    this.currentFilterType = 'include';
    this.currentFilterValue = '';
  }
}



// WEBPACK FOOTER //
// ./client/app/global/field-filter/field-filter.component.ts